import { FC } from "react";

export const IconGitFork: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13.5C8.9665 13.5 9.75 12.7165 9.75 11.75C9.75 10.7835 8.9665 10 8 10C7.0335 10 6.25 10.7835 6.25 11.75C6.25 12.7165 7.0335 13.5 8 13.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.75 6C12.7165 6 13.5 5.2165 13.5 4.25C13.5 3.2835 12.7165 2.5 11.75 2.5C10.7835 2.5 10 3.2835 10 4.25C10 5.2165 10.7835 6 11.75 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 6C5.2165 6 6 5.2165 6 4.25C6 3.2835 5.2165 2.5 4.25 2.5C3.2835 2.5 2.5 3.2835 2.5 4.25C2.5 5.2165 3.2835 6 4.25 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25001 6V6.5C4.24919 6.69721 4.28742 6.89264 4.36251 7.075C4.4376 7.25736 4.54806 7.42305 4.68751 7.5625C4.82696 7.70196 4.99265 7.81241 5.17501 7.8875C5.35737 7.96259 5.5528 8.00083 5.75001 8H10.25C10.4472 8.00083 10.6427 7.96259 10.825 7.8875C11.0074 7.81241 11.1731 7.70196 11.3125 7.5625C11.452 7.42305 11.5624 7.25736 11.6375 7.075C11.7126 6.89264 11.7508 6.69721 11.75 6.5V6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8V10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
